import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { MercureUrl } from "../../../../App";
import { games, TOPICS_LIST } from "../../../../utils/consts";
import { generateJWSToken } from "../../../../utils/mercureAuth";
import ucFirst from "../../../../utils/ucFirst";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { closableNotification } from "../../notification/ClosableNotification";
import {
  StyledFlexWrapper,
  StyledGameItem,
  StyledGamesItemTitle, StyledHeaderLeftSidebar,
  StyledLeftSidebarGamesWrapper
} from "./styledLeftSidebarGames";
import { generatePath } from "../../../../utils/getLanguage";
import { useBetween } from "use-between";
import BurgerStates from "../../mobileNavigation/BurgerStates";
import SocketChatStates from "../../../../store/SocketChatStates";

const LeftSidebarGamesList = ({ setVisible, setMenu }) => {
  const { t } = useTranslation("leftSidebar");
  const {gameOnlineData} = useBetween(SocketChatStates);

  const {
    handleClearAll
  } = useBetween(BurgerStates);

  return (
    <StyledLeftSidebarGamesWrapper id="games">
      <StyledHeaderLeftSidebar>
        <h3>{t("games")}</h3>
        <span
          className="cancel" onClick={() => {
          setVisible(false);
          setMenu("");
        }}
        >✕</span>
      </StyledHeaderLeftSidebar>
      <StyledFlexWrapper>
        <StyledGameItem
          game="balls"
          as={NavLink}
          to={generatePath("/balls")}
          onClick={() => {
            setVisible(false);
            setMenu("");
            localStorage.setItem("gamePage", "/balls");
            handleClearAll();
          }}
        >
          <StyledGamesItemTitle className="game-name" top="26" left="120">
            {t("balls")}
          </StyledGamesItemTitle>
          <span>{gameOnlineData?.balls ?? 0} {t("users")}</span>
        </StyledGameItem>
        <StyledGameItem
          game="dice"
          as={NavLink}
          to={generatePath("/")}
          onClick={() => {
            setVisible(false);
            setMenu("");
            localStorage.setItem("gamePage", "/");
            handleClearAll();
          }}
        >
          <StyledGamesItemTitle className="game-name" top="26" left="-3">
            {t("dice")}
          </StyledGamesItemTitle>
          <span>{gameOnlineData?.dice ?? 0} {t("users")}</span>
        </StyledGameItem>
      </StyledFlexWrapper>
    </StyledLeftSidebarGamesWrapper>
  );
};

export default LeftSidebarGamesList;